import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Helmet } from 'react-helmet';
import { StaticPageView } from '@/components/pages/static/StaticPageView/StaticPageView';
import Layout from '@/container/Layout';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { META_DESCRIPTION } from '@/utils/constants/seo/meta';
import { STATIC_PAGE_CONTENT } from '@/utils/constants/static/pageContent';
import { getAbsolutePath, termsProffitSearchPath } from '@/utils/router/links';
/**
 * PS利用規約ページ（認証以外のアクセス制限）
 * NOTE: ページ構成統一のため作成してあります。アクセス制限等ができた場合ここに処理を追加する
 */
export const TermsPsPage = () => {
    const title = 'PROFFIT SEARCH 利用規約';
    const headTitle = `${title} | PROFFIT`;
    const titleEn = 'Terms';
    const description = META_DESCRIPTION.terms();
    const url = termsProffitSearchPath();
    const html = STATIC_PAGE_CONTENT.termsPs;
    return (_jsxs(Layout, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: headTitle }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: headTitle, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'article', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(url), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(StaticPageView, { activePath: url, className: 'mt-60 lg:mt-80', headEnglishText: titleEn, headText: title, html: html })] }));
};
